<template>
    <div class="w-6 h-6">
        <base-dropdown placement="bottom-end">
            <button
                slot="trigger"
                slot-scope="{ is_open, toggle }"
                :class="{ 'shadow-outline': is_open }"
                class="w-6 h-6 btn btn-none"
                type="button"
                @click.prevent="toggle"
            >
                <base-svg
                    name="icon-dots-horizontal"
                    class="w-full h-full"
                />
            </button>
            <div
                slot="menu"
                slot-scope="{ close }"
                class="py-2 text-white rounded shadow-lg bg-grey-darker mt-3px"
            >
                <router-link
                    v-if="task.can_edit"
                    :to="{
                        name: $router.fix('dashboard.*.tasks.edit'),
                        params: {
                            task: task.uuid
                        }
                    }"
                    class="block p-3 font-semibold leading-none no-underline text-inherit hover:bg-grey-darker-10pcl"
                >
                    Edit
                </router-link>

                <button
                    v-if="task.can_delete"
                    class="block p-3 font-semibold leading-none no-underline text-inherit hover:bg-grey-darker-10pcl"
                    @click.prevent="close(() => { show_tasks_destroy_modal = true })"
                >
                    Delete
                </button>
            </div>
        </base-dropdown>

        <task-destroy-modal
            v-model="show_tasks_destroy_modal"
            :task="task"
            @success="onTaskDestroySuccess"
        />
    </div>
</template>

<script>
    import TaskDestroyModal from '../../../../../components/task-destroy-modal'

    export default {
        components: {
            TaskDestroyModal
        },
        props: {
            task: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                show_tasks_destroy_modal: false
            }
        },
        methods: {
            onTaskDestroySuccess () {
                this.$router.push({
                    name: this.$router.fix('dashboard.*.tasks.index')
                })
            }
        }
    }
</script>
